/**
 * -------------------------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation.  All Rights Reserved.  Licensed under the MIT License.
 * See License in the project root for license information.
 * -------------------------------------------------------------------------------------------
 */
export const strings = {
    SkillsAndExperienceSectionTitle: 'Skills & Experience',
    AboutCompactSectionTitle: 'About',
    SkillsSubSectionTitle: 'Skills',
    LanguagesSubSectionTitle: 'Languages',
    WorkExperienceSubSectionTitle: 'Work Experience',
    EducationSubSectionTitle: 'Education',
    professionalInterestsSubSectionTitle: 'Professional Interests',
    personalInterestsSubSectionTitle: 'Personal Interests',
    birthdaySubSectionTitle: 'Birthday',
    currentYearSubtitle: 'Current'
};
//# sourceMappingURL=strings.js.map